import { TranslationObject } from '../../i18n/translation';

const namespace = 'practiceactivity/vurdering';

const translations: TranslationObject = {
  vurderingsinnstillingerSaveSuccess: {
    id: `${namespace}.vurderingsinnstillingerSaveSuccess`,
    nb: 'Vurderingsinnstillingene ble lagret',
    en: 'Evaluation settings saved',
  },
  vurderingstypeLabel: {
    id: `${namespace}.vurderingstypeLabel`,
    nb: 'Velg vurderingstype',
    en: 'Choose type of evaluation',
  },
  kontinuerlig: {
    id: `${namespace}.kontinuerlig`,
    nb: 'Kontinuerlig',
    en: 'Continuous',
  },
  midtveisvurdering: {
    id: `${namespace}.midtveisvurdering`,
    nb: 'Midtveisvurdering',
    en: 'Mid-term evaluation',
  },
  sluttvurdering: {
    id: `${namespace}.sluttvurdering`,
    nb: 'Sluttvurdering',
    en: 'Final evaluation',
  },
  vurderingsrollerLabel: {
    id: `${namespace}.vurderingsrollerLabel`,
    nb: 'Velg roller for vurderingen',
    en: 'Choose participants for the evaluation',
  },
  underviser: {
    id: `${namespace}.underviser`,
    nb: 'Underviser',
    en: 'Teacher',
  },
  veileder: {
    id: `${namespace}.veileder`,
    nb: 'Veileder',
    en: 'Supervisor',
  },
  student: {
    id: `${namespace}.student`,
    nb: 'Student',
    en: 'Student',
  },
  vurderingsinnstillingerSaveMidtveisError: {
    id: `${namespace}.vurderingsinnstillingerSaveMidtveisError`,
    nb: 'Midtveisvurdering kan kun velges dersom sluttvurdering også er valgt.',
    en: 'Midt-term evaluation can only be chosen if final evaluation is selected',
  },
  buttonSaveLabel: {
    id: `${namespace}.buttonSaveLabel`,
    nb: 'Lagre vurderingsinnstillingene',
    en: 'Save evaluation settings',
  },
};

export default translations;
